/**
 * Ticket 03: uploaded-paper mark schemes can belong to another question or
 * paper, and the marker used to follow them blindly (it told a student the
 * correct option B was wrong because the scheme row said "first option").
 * The marker now solves the question first, in a field written before the
 * feedback, and treats the scheme as advisory when the two disagree.
 *
 * Eval 8 Oct 2026 (gpt-5.4-mini, 15 cases x 3 runs: the reported paper's Q2/Q3
 * with a foreign scheme, 5 synthetic AQA-style MC questions right and wrong,
 * one open question): exact marks 43-45/45 vs 30-36/45 before. A separate
 * schemeConflict boolean was tried and dropped: it never fired on the real
 * conflict and fired once on a correct scheme.
 *
 * The schema-level sentence stays short: OpenAI rejects a
 * json_schema.description over 1024 chars, so the detail lives in the field.
 */
export const schemeCheckInstruction = (flagged: boolean): string =>
  ' Solve the question yourself first (independentAnswer); if the mark scheme contradicts your correct solution, mark by your solution.' +
  (flagged
    ? " This question's mark scheme was flagged as possibly belonging to another question."
    : '')

export const schemeCheckProperties = {
  independentAnswer: {
    type: 'string',
    description:
      'For interactive papers only: solve the question from the question text alone, ignoring the mark scheme. Give 2-4 short working steps, then the final answer; for multiple choice, check each option against your working and give the correct option letter and its value, e.g. "sqrt5 = 5^(1/2) = 5^(-a) so a = -1/2; 1/4 = 16^(-1/2) so b = -1/2. Final: B". If the mark scheme gives a different answer or refers to content that is not in this question, award marks against this solution and never tell the student that a correct answer is wrong because of the scheme. Never shown to the student.',
  },
}

export const SCHEME_CHECK_REQUIRED = ['independentAnswer']
